
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/[shortname]/finance-news",
      function () {
        return require("private-next-pages/investors/[shortname]/finance-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/[shortname]/finance-news"])
      });
    }
  